import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AsyncModalService } from 'src/app/services/shared/async-modal-service';
import { LabelPreparationService, LabelPreparationSetup, LabelPreparationSetupExportQRCode, LabelPreparationSetupExportFormQuestion } from 'src/app/services/settings/labelpreparation.service';
import { DatePipe } from '@angular/common';
import { QRCodeService, QRCodeSetup } from 'src/app/services/settings/qrcode.service';
import { ActivatedRoute } from '@angular/router';
import { Question } from 'src/app/services/settings/forms.service';
import { delayWhen } from 'rxjs/operators';

@Component({
    standalone: false,
    selector: 'app-labelpreparation-form',
    templateUrl: './label-preparation.form.component.html',
    styleUrls: ['./label-preparation.form.component.css'],
    providers: [LabelPreparationService]
})
export class LabelPreparationForm implements OnInit {

    @ViewChild("closeLabelPreparationSetupButton") closeLabelPreparationSetupButton: ElementRef;
    @Output("onSaveLabelPreparationSetupForm") onSaveLabelPreparationSetupForm: EventEmitter<LabelPreparationSetup> = new EventEmitter<LabelPreparationSetup>();
    @Output("onCloseLabelPreparationSetupModal") onCloseLabelPreparationSetupModal: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() labelPreparationSetup: LabelPreparationSetup;
    @Input() isViewMode: boolean;
    @Input() isEditMode: boolean;
    @Input() labelPreparationFormQuestions: Question[];
    @Input() labelPreparationHeaderCoreQuestions: any[];

    formQuestionOptions: { label: string, id: number }[] = [];
    labelPreparationQRCodeSetups: QRCodeSetup[];
    labelPreparationSetupFormGroup: FormGroup;
    selectedExportColumns: any[] = [];
    selectedExportQuestions: any[] = [];
    selectedExportQuestionId: any[] = [];
    selectedExportQRCodes: any[] = [];
    selectedExportQRCodeId: any[] = [];
    selectedExportColumnCollection: any[] = []

    formId: number;

    selectedQuesTableCols: any[] = [
        { field: 'id', header: 'Id', visible: false },
        { field: 'label', header: 'Export Form Questions & QR-Codes' }
    ];
    statusOptions = [
        { label: "Active", value: true },
        { label: "Inactive", value: false }
    ];

    constructor(
        private route: ActivatedRoute,
        private changeDetector: ChangeDetectorRef,
        private asyncModalService: AsyncModalService,
        private qrCodeService: QRCodeService,
        private labelPreparationService: LabelPreparationService
    ) {
        this.changeDetector = changeDetector;
        this.asyncModalService = asyncModalService;
        this.qrCodeService = qrCodeService;
    }

    async ngOnInit() {
        this.formId = 0;
        //set form-id
        let params = this.route.snapshot.params;
        if (params["id"]) {
            this.formId = +params["id"];
            this.labelPreparationService.formEntryNumber = this.formId;
        }
        //set form-area
        this.labelPreparationService.formArea = this.route.snapshot.data.formArea;
        //create question object to form 'Id' question
        this.formQuestionOptions = [];
        //add 'Id' option on the top of the list
        this.formQuestionOptions.unshift({ id: 0, label: 'ID' });
        //add header core questions 
        this.labelPreparationHeaderCoreQuestions.map(coreQuestionValue => {
            let coreQuestion = this.getCoreQuestion(coreQuestionValue);
            if (coreQuestion)
                this.formQuestionOptions.push({ id: coreQuestion.id, label: coreQuestion.label });
        });
        //filter form questions
        this.labelPreparationFormQuestions = this.labelPreparationFormQuestions.filter(
            (x) =>
                (x.type != "Header" &&
                    x.type != "File" &&
                    x.extendedType != "Note" &&
                    x.type != "Notification" &&
                    x.type != "Page" &&
                    x.type != "Plant"
                ) &&
                x.label != null
        );
        //add form questions
        this.labelPreparationFormQuestions.map(x => {
            this.formQuestionOptions.push({ id: x.id, label: x.label });
        });

        //setup label preparation setup form
        this.bindLabelPreparationSetupForm();
        if (this.labelPreparationSetup.id == 0 && !this.isEditMode && !this.isViewMode) {
            this.selectedExportQRCodeId = [];
            this.selectedExportQuestions = [];
            this.selectedExportQuestionId = [];
            this.selectedExportQRCodes = [];
            this.selectedExportColumns = [];
            this.labelPreparationSetup.labelPreparationSetupExportFormQuestions = [];
            this.labelPreparationSetup.labelPreparationSetupExportQRCodes = [];
        }
        else {
            this.labelPreparationSetup.labelPreparationSetupExportFormQuestions.forEach(labelPreparationSetupExportFormQuestion => {
                this.selectedExportQuestionId.push(labelPreparationSetupExportFormQuestion.questionId);
                this.selectedExportColumnCollection.push(
                    {
                        id: labelPreparationSetupExportFormQuestion.questionId,
                        order: labelPreparationSetupExportFormQuestion.order,
                        isFormQuestion: true
                    }
                );
            });

            this.labelPreparationSetup.labelPreparationSetupExportQRCodes.forEach(labelPreparationSetupExportQRCode => {
                this.selectedExportQRCodeId.push(labelPreparationSetupExportQRCode.qrCodeSetupId);
                this.selectedExportColumnCollection.push(
                    {
                        id: labelPreparationSetupExportQRCode.qrCodeSetupId,
                        order: labelPreparationSetupExportQRCode.order,
                        isFormQuestion: false
                    }
                );
            });
        }
        //fetch qrcode setups
        this.labelPreparationQRCodeSetups = await this.qrCodeService.getAllActive().toPromise();
        this.setLabelPreparationExportItems();
    }

    addRemoveExportColumn(event, isFormQuestion) {
        //if single item selected/de-selected
        if (typeof event.itemValue != 'undefined') {
            //if single item selected
            if (event.value.indexOf(event.itemValue.id) > -1) {
                this.addToExportColumnCollection(event.itemValue.id, isFormQuestion);
            }
            //if single item de-selected
            else if (event.value.indexOf(event.itemValue.id) == -1) {
                let currSelectExportIndex =
                    this.selectedExportColumns.
                        findIndex(
                            selectedExportColumn =>
                                selectedExportColumn.id == event.itemValue.id &&
                                selectedExportColumn.isFormQuestion == isFormQuestion
                        );

                if (currSelectExportIndex > -1)
                    this.selectedExportColumns.splice(currSelectExportIndex, 1);
            }
        }
        //if multiple item selected/de-selected
        else if (typeof event.itemValue == 'undefined') {
            //if multiple item selected
            if (event.value.length > 0) {
                event.value.forEach(currentSelectedExportId => {
                    this.addToExportColumnCollection(currentSelectedExportId, isFormQuestion);
                });
            }
            //if multiple item de-selected
            else {
                this.selectedExportColumns = [];
            }
        }
    }

    removeItem(index: number, events?: Event) {
        if (events) {
            events.stopPropagation();
            events.preventDefault();
        }
        this.selectedExportColumns.find(x => {
            if (x.id == this.selectedExportColumns[index].id) {
                this.selectedExportColumns.splice(index, 1);

                if (x.isFormQuestion)
                    this.selectedExportQuestionId = this.selectedExportQuestionId.filter(a => a !== x.id);
                else
                    this.selectedExportQRCodeId = this.selectedExportQRCodeId.filter(a => a !== x.id);

                this.changeDetector.detectChanges();
                return true;
            }

            return false;
        });
    }

    onMoveUp(formSelectedItemIndex) {
        let fromIndex = formSelectedItemIndex;
        let toIndex = formSelectedItemIndex - 1;
        this.swap(fromIndex, toIndex);
    }

    onMoveDown(formSelectedItemIndex) {
        let fromIndex = formSelectedItemIndex;
        let toIndex = formSelectedItemIndex + 1;
        this.swap(fromIndex, toIndex);
    }

    onSubmit() {
        if (!this.isValid()) {
            return false;
        }
        else if (this.formId > 0 && !this.isViewMode) {
            //set export form field
            this.setLabelPreparationEntityOnSave();
            if (this.labelPreparationSetup.id > 0 && this.isEditMode)
                this.update();
            else if (this.labelPreparationSetup.id == 0 && !this.isEditMode)
                this.add();
        }
    }

    closeLabelPreparationSetupModal() {
        this.onCloseLabelPreparationSetupModal.emit();
    }

    private async setLabelPreparationExportItems() {
        this.selectedExportColumnCollection.sort((a, b) => (a.order > b.order) ? 1 : -1);
        this.selectedExportColumnCollection.forEach(selectedExportColumn => {
            this.addToExportColumnCollection(selectedExportColumn.id, selectedExportColumn.isFormQuestion);
        });
    }

    private bindLabelPreparationSetupForm() {
        this.labelPreparationSetupFormGroup = new FormGroup({
            name: new FormControl({ value: this.labelPreparationSetup.name, disabled: this.isViewMode }, {
                validators: [Validators.maxLength(25)],
                updateOn: "change"
            }),
            lastUpdatedBy: new FormControl
                (
                    {
                        value: (this.labelPreparationSetup.modifiedBy != "" ? this.labelPreparationSetup.modifiedBy : this.labelPreparationSetup.createdBy ?? ""),
                        disabled: true
                    }
                ),
            lastUpdatedOn: new FormControl
                (
                    {
                        value: new DatePipe("en-US").transform(
                            this.labelPreparationSetup.modified ? this.labelPreparationSetup.modified : this.labelPreparationSetup.created, "yyyy-MM-dd HH:mm"
                        ),
                        disabled: true
                    }
                ),
            status: new FormControl({ value: this.labelPreparationSetup.isActive, disabled: this.isViewMode }, { updateOn: "change" }),
            selectedExportQuestions: new FormControl({ value: "", disabled: this.isViewMode }),
            selectedExportQRCodes: new FormControl({ value: "", disabled: this.isViewMode })
        });
    }

    private add() {
        //add qrcode setup setting
        this.labelPreparationService.add(this.labelPreparationSetup).subscribe(
            () => { },
            (err) => {
                this.closeLabelPreparationSetupButton.nativeElement.click();
                this.asyncModalService.getModalResponse(err.error);
            },
            () => {
                this.closeLabelPreparationSetupButton.nativeElement.click();
                this.onSaveLabelPreparationSetupForm.emit();
            }
        );
    }

    private update() {
        //update qrcode setup setting
        this.labelPreparationService.edit(this.labelPreparationSetup).subscribe(
            () => { },
            (err) => {
                this.closeLabelPreparationSetupButton.nativeElement.click();
                this.asyncModalService.getModalResponse(err.error);
            },
            () => {
                this.closeLabelPreparationSetupButton.nativeElement.click();
                this.onSaveLabelPreparationSetupForm.emit();
            }
        );
    }

    private setLabelPreparationEntityOnSave() {
        this.labelPreparationSetup.name = this.labelPreparationSetupFormGroup.value.name;
        this.labelPreparationSetup.formId = this.formId ?? 0;
        this.labelPreparationSetup.entryNumber = this.labelPreparationSetup.entryNumber ?? 0;
        this.labelPreparationSetup.isActive = this.labelPreparationSetupFormGroup.value.status;
        this.labelPreparationSetup.labelPreparationSetupExportFormQuestions = [];
        this.labelPreparationSetup.labelPreparationSetupExportQRCodes = [];
        this.selectedExportColumns.forEach((selectedExportColumn, selectedExportColumnIndex) => {
            if (selectedExportColumn.isFormQuestion) {
                let labelPreparationFormQuestion = this.formQuestionOptions.find(x => x.id == selectedExportColumn.id);
                if (labelPreparationFormQuestion) {
                    let entity = new LabelPreparationSetupExportFormQuestion();
                    entity = {
                        id: 0,
                        labelPreparationSetupId: this.labelPreparationSetup.id,
                        questionId: labelPreparationFormQuestion.id,
                        order: selectedExportColumnIndex
                    };

                    this.labelPreparationSetup.labelPreparationSetupExportFormQuestions.push(entity);
                }
            }
            else {
                let labelPreparationQRCodeSetup = this.labelPreparationQRCodeSetups.find(x => x.id == selectedExportColumn.id);
                if (labelPreparationQRCodeSetup) {
                    let entity = new LabelPreparationSetupExportQRCode();
                    entity = {
                        id: 0,
                        labelPreparationSetupId: this.labelPreparationSetup.id,
                        qrCodeSetupId: labelPreparationQRCodeSetup.id,
                        order: selectedExportColumnIndex
                    };

                    this.labelPreparationSetup.labelPreparationSetupExportQRCodes.push(entity);
                }
            }
        });
    }

    private swap(fromIndex, toIndex) {
        var formSelectedItem = this.selectedExportColumns[fromIndex];
        this.selectedExportColumns.splice(fromIndex, 1);
        this.selectedExportColumns.splice(toIndex, 0, formSelectedItem);
    }

    private getCoreQuestion(value: string) {
        let coreQuestion = null;
        switch (value) {
            case "askStructureReference":
                coreQuestion = { id: -1, label: 'Structure Reference' };
                break;
            case "askLevel":
                coreQuestion = { id: -2, label: 'Level' };
                break;
            case "askElevation":
                coreQuestion = { id: -3, label: 'Elevation' };
                break;
            case "askCores":
                coreQuestion = { id: -4, label: 'Cores' };
                break;
            case "askElement":
                coreQuestion = { id: -5, label: 'Element' };
                break;
            case "askPackage":
                coreQuestion = { id: -6, label: 'Package' };
                break;
            case "askClient":
                coreQuestion = { id: -7, label: 'Client' };
                break;
            case "askProjectName":
                coreQuestion = { id: -8, label: 'Project Name' };
                break;
            case "askProjectAddress":
                coreQuestion = { id: -9, label: 'Project Address' };
                break;
        }

        return coreQuestion;
    }

    private addToExportColumnCollection(currentSelectedQuesId, isFormQuestion) {
        //check if item on the list (added item) already exist
        let formExist = this.selectedExportColumns.find(x => x.id == currentSelectedQuesId && x.isFormQuestion == isFormQuestion);
        let selectedExportFormQues;
        if (isFormQuestion) {
            let formQuestion = this.formQuestionOptions.find(x => x.id == currentSelectedQuesId);
            if (formQuestion)
                selectedExportFormQues = { id: formQuestion.id, label: formQuestion.label, isFormQuestion: true };
        }
        else {
            let labelPreparationQRCodeSetup = this.labelPreparationQRCodeSetups.find(x => x.id == currentSelectedQuesId);
            if (labelPreparationQRCodeSetup)
                selectedExportFormQues = { id: labelPreparationQRCodeSetup.id, label: labelPreparationQRCodeSetup.name, isFormQuestion: false };
        }

        if (selectedExportFormQues != null && typeof formExist == 'undefined') {
            //get list of selected items from currently active form accordion
            let selectedExportColumns = this.selectedExportColumns;
            //add new item
            selectedExportColumns.push(selectedExportFormQues);
            //update the list with items
            this.selectedExportColumns = selectedExportColumns;
        }
    }

    private isValid(): boolean {
        let errMsg: string;
        let isValid: boolean = true;
        if (this.labelPreparationSetupFormGroup.controls["name"].value == '') {
            errMsg = "Label Preparation Name is required.";
            this.asyncModalService.getModalResponse(errMsg);
            isValid = false;
        }
        else if (this.selectedExportColumns.length == 0) {
            errMsg = "At least one Question or QR Code is required";
            this.asyncModalService.getModalResponse(errMsg);
            isValid = false;
        }

        return isValid;
    }
}
